import { render, staticRenderFns } from "./ImageAmbiance.vue?vue&type=template&id=3fd2c6b2&scoped=true&"
import script from "./ImageAmbiance.vue?vue&type=script&lang=js&"
export * from "./ImageAmbiance.vue?vue&type=script&lang=js&"
import style0 from "./ImageAmbiance.vue?vue&type=style&index=0&id=3fd2c6b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd2c6b2",
  null
  
)

export default component.exports